import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { VideoModalProvider } from "./context/VideoModalContext";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./pages/AuthCallback";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Journal from "./pages/Journal";
import Community from "./pages/Community";
import Resources from "./pages/Resources";
import Tools from "./pages/Tools";
import Business from "./pages/Business";
import Newsletter from "./pages/Newsletter";
import Admin from "./pages/Admin";
import Watch from "./pages/Watch";
import { MotionConfig } from "framer-motion";
import "./App.css";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/tools" element={<Tools />} />
      <Route path="/business" element={<Business />} />
      <Route path="/newsletter" element={<Newsletter />} />
      <Route path="/community" element={<Community />} />
      <Route path="/watch" element={<Watch />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/journal" element={<ProtectedRoute><Journal /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <MotionConfig reducedMotion="user">
      <AuthProvider>
        <BrowserRouter>
          <VideoModalProvider>
            <AppRouter />
            <Toaster theme="dark" position="bottom-right" />
          </VideoModalProvider>
        </BrowserRouter>
      </AuthProvider>
      </MotionConfig>
    </div>
  );
}
